export const getOption = (options, key, value, grouped) => {
  let opts = options;
  if (grouped) {
    opts = options.reduce((arr, group) => {
      return [...arr, ...group.options];
    }, []);
  }
  return opts.find((option) => option[key] === value);
};
